export const CIPHER_INFO = {
  'aes-128-cbc': { ivLength: 16, keyLength: 16 },
  'aes-128-cbc-hmac-sha1': { ivLength: 16, keyLength: 16 },
  'aes-128-cbc-hmac-sha256': { ivLength: 16, keyLength: 16 },
  'aes-128-cfb': { ivLength: 16, keyLength: 16 },
  'aes-128-cfb1': { ivLength: 16, keyLength: 16 },
  'aes-128-cfb8': { ivLength: 16, keyLength: 16 },
  'aes-128-ctr': { ivLength: 16, keyLength: 16 },
  'aes-128-ecb': { ivLength: undefined, keyLength: 16 },
  'aes-128-ocb': { ivLength: 12, keyLength: 16 },
  'aes-128-ofb': { ivLength: 16, keyLength: 16 },
  'aes-128-xts': { ivLength: 16, keyLength: 32 },
  'aes-192-cbc': { ivLength: 16, keyLength: 24 },
  'aes-192-cfb': { ivLength: 16, keyLength: 24 },
  'aes-192-cfb1': { ivLength: 16, keyLength: 24 },
  'aes-192-cfb8': { ivLength: 16, keyLength: 24 },
  'aes-192-ctr': { ivLength: 16, keyLength: 24 },
  'aes-192-ecb': { ivLength: undefined, keyLength: 24 },
  'aes-192-ocb': { ivLength: 12, keyLength: 24 },
  'aes-192-ofb': { ivLength: 16, keyLength: 24 },
  'aes-256-cbc': { ivLength: 16, keyLength: 32 },
  'aes-256-cbc-hmac-sha1': { ivLength: 16, keyLength: 32 },
  'aes-256-cbc-hmac-sha256': { ivLength: 16, keyLength: 32 },
  'aes-256-cfb': { ivLength: 16, keyLength: 32 },
  'aes-256-cfb1': { ivLength: 16, keyLength: 32 },
  'aes-256-cfb8': { ivLength: 16, keyLength: 32 },
  'aes-256-ctr': { ivLength: 16, keyLength: 32 },
  'aes-256-ecb': { ivLength: undefined, keyLength: 32 },
  'aes-256-ocb': { ivLength: 12, keyLength: 32 },
  'aes-256-ofb': { ivLength: 16, keyLength: 32 },
  'aes-256-xts': { ivLength: 16, keyLength: 64 },
  'aes-128-ccm': { ivLength: 12, keyLength: 16 },
  'aes-128-gcm': { ivLength: 12, keyLength: 16 },
  'aes-192-ccm': { ivLength: 12, keyLength: 24 },
  'aes-192-gcm': { ivLength: 12, keyLength: 24 },
  'aes-256-ccm': { ivLength: 12, keyLength: 32 },
  'aes-256-gcm': { ivLength: 12, keyLength: 32 },
  'id-aes128-ccm': { ivLength: 12, keyLength: 16 },
  'id-aes128-gcm': { ivLength: 12, keyLength: 16 },
  'id-aes192-ccm': { ivLength: 12, keyLength: 24 },
  'id-aes192-gcm': { ivLength: 12, keyLength: 24 },
  'id-aes256-ccm': { ivLength: 12, keyLength: 32 },
  'id-aes256-gcm': { ivLength: 12, keyLength: 32 },
} as const
